class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    // Mobile form not autosubmit
    if (facetForm && facetForm.id !== 'FacetFiltersFormMobile') {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById(
      'ProductCountDesktop',
    );
    document
      .getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static getCookieByCollection(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        // add event wishlist
        if (typeof initButtons === 'function' && typeof initGrid === 'function') {
          initButtons();
          initGrid();
        }
        if (typeof initializeScrollAnimationTrigger === 'function')
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
     // add event wishlist
    if (typeof initButtons === 'function' && typeof initGrid === 'function') {
      initButtons();
      initGrid();
    }
    if (typeof initializeScrollAnimationTrigger === 'function')
      initializeScrollAnimationTrigger(html.innerHTML);
  }
  static applyDisplayDiscount(cents, discountPercent = 0) {
    const discounted = Math.ceil(cents * (1 - discountPercent / 100));
    return discounted;
  }
  static renderPriceDiscount(html, discount, code = null) {
    if (!html) return;

    var collectionEl = document.querySelector('.name-collection-page');
    var collectionType = collectionEl ? collectionEl.textContent : '';
    if(code == 'BF50FB' && collectionType != 'Personalized Blanket') return; 
    if(code == 'BF42FB' && collectionType != 'Holiday Ornaments') return; 

    var formatWithCurrency = document.body.dataset.moneyFormat;
    if (!formatWithCurrency) {
      return;
    }

    html.querySelectorAll('#product-grid li.grid__item').forEach((el) => {
      if (!el) return;

      const regularEl = el.querySelector('.price__regular .price-item.price-item--regular.money');
      if (regularEl) {
        const cents = parseInt(regularEl.getAttribute('data-price'), 10);
        if (!cents) return;

        const discounted = FacetFiltersForm.applyDisplayDiscount(cents, discount);
        const priceDiscount = Shopify.formatMoney(discounted, formatWithCurrency);

        const priceContainer = el.querySelector('.price__container');
        if (priceContainer) {
          priceContainer.insertAdjacentHTML('beforeend', getPriceDiscountCollections(priceDiscount));
        }
      }

      const priceCompare = el.querySelector('.box-price-final .price-item.price-item--regular.money');
      if (priceCompare) {
        priceCompare.classList.remove('hidden');
        priceCompare.classList.add('custom');
      }

      const priceSale = el.querySelector('.box-price-final .price-item.price-item--sale.price-item--last.money');
      if (priceSale) {
        priceSale.classList.add('hidden');
      }
    });

  }
  static renderProductGridContainer(html) {
    const TIMES_TAMP_OFF_BFCM = 1766595599;
    function getCurrentLATime() {
        const now = new Date();
        // Convert current time to America/Los_Angeles timezone
        const laTimeString = now.toLocaleString("en-US", {
          timeZone: "America/Los_Angeles",
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false
        });

        // Parse lại thành date object
        const [month, day, year] = laTimeString.split(',')[0].split('/');
        const [hour, minute, second] = laTimeString.split(',')[1].split(':');

        return new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day),
          parseInt(hour),
          parseInt(minute),
          parseInt(second)
        ).getTime();
    }
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
    // show price discount UTM campaign for Meta Ads
    const utmValue = FacetFiltersForm.getCookieByCollection('utm_discount');
    const regex = /BF(\d+)FB|FB(\d+)/;
    let discount = utmValue?.match(regex)?.[1] || utmValue?.match(regex)?.[2];
    const codeBFCM = 'BFCM';
    const codeCS25 = 'CS25';
    if(utmValue == codeBFCM){
      discount = 30;
    }

    if(utmValue == codeCS25){
      discount = 25;
    }

    let ITEM_DISCOUNT = discountUTM?.find(item=> item.code == utmValue);
    const productType = document.querySelector(".name-collection-page")?.textContent ;
    const COUNTRY_CODE = document.body.getAttribute('country-code');
    if(ITEM_DISCOUNT && ITEM_DISCOUNT.ads == 'meta' && ITEM_DISCOUNT?.collection?.includes(productType) || ITEM_DISCOUNT?.ads == 'meta' && ITEM_DISCOUNT?.collection == null){
      discount = ITEM_DISCOUNT.discount;
      FacetFiltersForm.renderPriceDiscount(document.getElementById('ProductGridContainer'), discount, utmValue);      
    }

    if(!ITEM_DISCOUNT && utmValue?.match(regex)?.[1]){
      FacetFiltersForm.renderPriceDiscount(document.getElementById('ProductGridContainer'), discount, utmValue);   
    }
    // Hide BFCM MHS20
    // else if(ITEM_DISCOUNT && ITEM_DISCOUNT.ads == 'google' || ITEM_DISCOUNT && !ITEM_DISCOUNT?.collection?.includes(productType)){
    //   const discountBFCM = 20;
    //   FacetFiltersForm.renderPriceDiscount(document.getElementById('ProductGridContainer'), discountBFCM);
    // }
    // else if(!utmValue && productType == 'Jewelry Dish' || ITEM_DISCOUNT && !ITEM_DISCOUNT?.collection?.includes(productType) && productType == 'Jewelry Dish'){
    //   // show BFCM Dish
    //   const discountBFCM = 20;
    //   FacetFiltersForm.renderPriceDiscount(document.getElementById('ProductGridContainer'), discountBFCM);
    // }
    // End Hide BFCM MHS20
    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const countEl = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount');
    if (!countEl) return;
    const count = countEl.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter'),
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById('FacetFiltersFormMobile')
      .closest('menu-drawer')
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form',
    );
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(
        event.target.closest('form'),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm'
          ) {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf('?') + 1,
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

//check firefox
document.addEventListener('DOMContentLoaded', function () {
  if (navigator.userAgent.includes("Firefox") && window.innerWidth > 768) {
    const facets = document.querySelectorAll('details.facets__disclosure-vertical.js-filter');
    const mainFilters = document.getElementById('main-collection-filters');
    if (!mainFilters) return;
    if (facets.length > 0) {
      mainFilters.classList.add('active');
    } else {
      mainFilters.classList.remove('active');
    }
  }
});